/* --------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

import _ from 'lodash';
import service from '../../services/responses';

const RESPONSE_ONE = 'RESPONSE_ONE';
const RESPONSE_DELETE = 'RESPONSE_DELETE';
const RECORDING_RESPONSES = 'RECORDING_RESPONSES';
const RESPONSES_RESET = 'RESPONSES_RESET';

const state = {
  responses: {
    // $recordingId: []
  },
};

const mutations = {
  [RECORDING_RESPONSES] (state, responses) {
    if (!responses || !responses.length) return;
    responses.forEach((response) => {
      const recordingId = response.recordingId;
      if (!state.responses[recordingId]) {
        state.responses[recordingId] = [];
      }

      // Delete any prior version
      const innerList = state.responses[recordingId];
      const index = _.findIndex(innerList, s => s.id === response.id);
      if (index >= 0) {
        innerList.splice(index, 1);
      }

      state.responses[recordingId].push(response);
    });
  },
  [RESPONSE_ONE] (state, responseData) {
    if (!state.responses[responseData.recordingId]) {
      state.responses[responseData.recordingId] = [];
    }

    const response = _.find(
      state.responses[responseData.recordingId],
      s => s.id === responseData.id
    );
    if (response) {
      _.assign(response, responseData);
    } else {
      state.responses[responseData.recordingId].push(responseData);
    }
  },
  [RESPONSES_RESET] (state) {
    state.responses = {};
  },
  [RESPONSE_DELETE] (state, response) {
    // not using _.pull so Vue detects the change
    const innerList = state.responses[response.recordingId];
    const index = _.findIndex(innerList, s => s.id === response.id);
    if (index >= 0) {
      innerList.splice(index, 1);
    }
  },
};

const actions = {
  getResponsesForRecording: ({ }, recordingId) => {
    return state.responses[recordingId];
  },
  registerRecordingResponses: ({ commit }, data) => {
    return commit(RECORDING_RESPONSES, data);
  },
  saveRecordingResponse: ({ commit }, data) => {
    if (data.id) {
      // Update existing response
      return service.update(data)
        .then((response) => {
          return commit(RESPONSE_ONE, response);
        });
    }
    return service.create(data)
      .then((response) => {
        return commit(RESPONSE_ONE, response);
      });
  },
  deleteResponse: ({ commit }, response) => {
    return service.delete(response)
      .then(() => {
        commit(RESPONSE_DELETE, response);
      });
  },
  resetResponse: ({ commit }) => {
    commit(RESPONSES_RESET);
  }
};

const getters = {
  allResponses: state => state.responses,
};

export default {
  state,
  mutations,
  actions,
  getters
};
